// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h3 {\n  text-align: center;\n}\n.warning {\n  text-align: center;\n  padding: 25px 0;\n}", ""]);
// Exports
module.exports = exports;
